<style>

</style>
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <transition name="fade">
        <div>
          <div class="borderAndMarginBottom" v-if="showFilterCase == true">
            <div class="vx-row">

              <div class="vx-col md:w-1/6 mt-2 w-full" v-if="showTopic == true" style="min-width:300px">
                <div class="vx-row">
                  <div class="text-topic" style="min-width:100px">
                    <span><b>{{$t('aticleDetail.topic')}}:</b></span>
                  </div>
                  <div class="topic-selected">
                    <v-select v-model="topicSelected" :options="optionalsTopic" placeholder="Chọn loại chủ đề"
                              @input="findByTopicId" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  </div>
                </div>
              </div>

              <div class="vx-col md:w-1/6 mt-2 w-full" style="min-width:200px">
                <div class="vx-col w-full">
                  <span> <b>S{{$t('aticleDetail.sort')}}: </b> </span>

                  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                    <span v-if="valueText"><b style="color:#277DF6">{{ valueText }}</b></span>
                    <span v-if="valueOldestPost"><b style="color:#277DF6">{{ valueOldestPost }}</b></span>
                    <span v-if="valueInteractive"><b style="color:#277DF6">{{ valueInteractive }}</b></span>
                    <span v-if="valueInteractiveUp"><b style="color:#277DF6">{{ valueInteractiveUp }}</b></span>
                    <feather-icon icon="ChevronDownIcon" style="vertical-align:middle;width:1rem"></feather-icon>
                    <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="clickNewPost">
                          <!-- <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4" /> -->
                          <span class="ml-2" style="vertical-align:middle">{{$t('article.newsFeed')}}</span>
                        </li>

                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="clickPriceDown">
                          <!-- <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4" /> -->
                          <span class="ml-2" style="vertical-align:middle">{{$t('articleDetail.newsOld')}}</span>
                        </li>
                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="clickPriceUp">
                          <!-- <feather-icon icon="ArrowUpIcon" svgClasses="w-4 h-4" /> -->
                          <span class="ml-2" style="vertical-align:middle">{{$t('article.ascendingLevel')}}</span>
                        </li>

                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="clickDown">
                          <!-- <feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" /> -->
                          <span class="ml-2" style="vertical-align:middle">{{$t('article.newsOld')}}</span>
                        </li>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

              </div>
              <div class="vx-col md:w-1/6 mt-2 w-full" style="min-width:200px">
                <div class="vx-col w-full">
                  <span> <b>{{$t('title.shades')}}: </b> </span>

                  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                    <span v-if="valueTextAll"><b style="color:#277DF6">{{ valueTextAll }}</b></span>
                    <span v-if="valueTextPositive"><b style="color:#277DF6">{{ valueTextPositive }}</b></span>
                    <span v-if="valueTextNegative"><b style="color:#277DF6">{{ valueTextNegative }}</b></span>
                    <span v-if="valueTextInter"><b style="color:#277DF6">{{ valueTextInter }}</b></span>
                    <feather-icon icon="ChevronDownIcon" style="vertical-align:middle;width:1rem"></feather-icon>
                    <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="getListFacebook">
                          <feather-icon icon="CircleIcon" svgClasses="w-4 h-4"/>
                          <span class="ml-2" style="vertical-align:middle">{{$t('articleDetail.all')}}</span>
                        </li>

                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="checkedClassificationPositive">
                          <feather-icon icon="SmileIcon" svgClasses="w-4 h-4" style="color:green"/>
                          <span class="ml-2" style="vertical-align:middle">{{$t('title.positive')}}</span>
                        </li>

                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="checkedClassificationNegative">
                          <feather-icon icon="FrownIcon" svgClasses="w-4 h-4" style="color:rgb(255,0,0)"/>
                          <span class="ml-2" style="vertical-align:middle;">{{$t('title.negative')}}</span>
                        </li>

                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="checkedClassificationInter">
                          <feather-icon icon="MehIcon" svgClasses="w-4 h-4"/>
                          <span class="ml-2" style="vertical-align:middle">{{$t('title.neutral')}}</span>
                        </li>
                        <!--
                                                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="checkedClassificationUndefined">
                                                          <feather-icon icon="XCircleIcon" svgClasses="w-4 h-4" />
                                                          <span class="ml-2" style="vertical-align:middle">Chưa xác định</span>
                                                        </li> -->
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

              </div>

              <!-- searh keyword -->
              <div class="vx-col md:w-1/6 w-full mt-2 search">
                <vs-input
                    style="width:100%"
                    :placeholder="$t('articleDetail.findByKeyword')"
                    data-vv-valuedate-on="blur"
                    v-validate="'required'"
                    v-on:keydown.enter="searchByKeyword"
                    v-model="formData.keyword"
                    icon-pack="feather"
                    icon="icon-search"
                ></vs-input>
              </div>
            </div>
          </div>

          <div class="borderAndMarginBottom" v-if="showFilterCase == true">
            <div class="vx-row">
              <div class="vx-col md:w-1/12 w-full" style="max-width:60px">
                <span><b>{{$t('articleDetail.source')}}:</b> </span>
              </div>

              <div class="vx-col md:w-11/12 w-full" style="margin-bottom:-10px">
                <div class="vx-row">
                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="getAll == true">
                    <label
                        :class="{'cursor-pointer article-news': findAll == false,'active cursor-pointer':findAll == true}"
                        @click="getAllData">{{$t('articleDetail.all')}}</label>
                  </div>

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="labelNews==true">
                    <label
                        :class="{'cursor-pointer article-news': findAll == false,'active cursor-pointer':findAll == true}"
                        @click="getAllNews">{{$t('articleDetail.all')}}</label>
                  </div>

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="labelSocial==true">
                    <label
                        :class="{'cursor-pointer article-news': findAll == false,'active cursor-pointer':findAll == true}"
                        @click="getAllSocial">{{$t('articleDetail.all')}}</label>
                  </div>

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min cursor-pointer" style="margin-right:10px"
                       v-if="showFacebookProfile == true">
                    <label
                        :class="{'cursor-pointer article-news': facePostCheckBox == false,'active cursor-pointer':facePostCheckBox == true}"
                        @click="articleChangeFacePost">{{$t('articleDetail.postFacebook')}}</label>
                  </div>

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="showFacebookComment == true">
                    <label
                        :class="{'cursor-pointer article-news': faceCommentCheckBox == false,'active cursor-pointer':faceCommentCheckBox == true}"
                        @click="articleChangeFaceComment">{{$t('articleDetail.commentFacebook')}}</label>
                  </div>

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="showNewsPost == true">
                    <label
                        :class="{'cursor-pointer article-news': newsPostCheckBox == false,'active cursor-pointer':newsPostCheckBox == true}"
                        @click="articleChangeNews">{{$t('articleDetail.news')}}</label>
                  </div>

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="showYoutube == true">
                    <label
                        :class="{'cursor-pointer article-news': youtubeCheckBox == false,'active cursor-pointer':youtubeCheckBox == true}"
                        @click="articleChangeYoutube">Youtube</label>
                  </div>

                  <!-- <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-if="showYoutubeComment == true">
                      <label :class="{'cursor-pointer article-news': youtubeCheckBoxComment == false,'active cursor-pointer':youtubeCheckBoxComment == true}" @click="articleChangeYoutubeComment">Bình luận Youtube</label>
                  </div> -->

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="showForum == true">
                    <label
                        :class="{'cursor-pointer article-news': forumCheckbox == false,'active cursor-pointer':forumCheckbox == true}"
                        @click="articleChangeForum">Forum</label>
                  </div>

                  <!-- <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-if="showForumComment == true">
                      <label :class="{'cursor-pointer article-news': forumCheckboxComment == false,'active cursor-pointer':forumCheckboxComment == true}" @click="articleChangeForumComment">Bình luận Forum</label>
                  </div> -->

                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                       v-if="showGoogle == true">
                    <label
                        :class="{'cursor-pointer article-news': googleCheckbox == false,'active cursor-pointer':googleCheckbox == true}"
                        @click="articleChangeGoogle">Google</label>
                  </div>
                  <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-for="(source,indexSource) in sourceData" :key="indexSource">
                    <label :class="{'cursor-pointer article-news text-size': source.checked == false ,'active cursor-pointer text-size' : source.checked == true}" @click="articleChangeOther(source,indexSource)"> {{source.name}} </label>
                  </div>
                </div>
              </div>

            </div>

          </div>

          <div :class="{'borderAndMarginBottom' :showFilterCase == true,'dash': showFilterCase == false}">
            <div class="vx-row" v-if="showFilterCase == false">
              <div class="vx-col w-full">
                <b class="title-size">{{$t('articleDetail.contentMention')}}</b>
              </div>
            </div>
            <div class="vx-row pb-0">
              <div class="vx-col md:w-2/3">
                <div class="vx-row">
                  <div class="vx-col md:w-1/12 w-full mt-3 marginLeft" style="min-width:150px; display:inline-block">
                    <span class="title-size"><b>{{$t('articleDetail.pages')}}:</b> </span>
                  </div>
                  <div
                      :class="{'vx-col md:w-4/12 pl-2 w-page' : showFilterCase == false,'vx-col md:w-5/12 pl-2' : showFilterCase == true }"
                      style=" display:inline-block">
                    <vs-pagination
                        :total="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage"
                        :per-page="perPage"
                        @change="onChangePage"
                    ></vs-pagination>
                  </div>
                  <div style=" display:inline-block; float:right;text-align:right"
                       :class="{'mt-3 md:w-6/12' :showFilterCase ==  false, 'mt-2 viewtotalsFull mr-12' :showFilterCase == true}">
                    <span class="text-size">{{$t('articleDetail.views')}}: {{ totalContent }}/<b>{{ totalElements }}</b> {{$t('articleDetail.content')}}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>
      </transition>
      <!-- LIST VIEW -->
      <template>
        <div class="vx-row">
          <div :class="{'vx-col md:w-2/3' :showFilterCase ==  false, 'vx-col w-full' :showFilterCase == true}">
            <vx-card class="card" v-for="(item,index) in rowDatas" :key="index" style="margin-bottom:10px;">

              <div class="vx-row comment">
                <div style="width: 14%">
                  <div class="facebook-profile">
                    <span v-if="item.source == 'page'" class="text-size">Facebook Page</span>
                    <span v-if="item.source == 'profile'" class="text-size">Facebook Profile</span>
                    <span v-if="item.source == 'group' && item.specialFields.source != 'group_private'" class="text-size">Facebook Group</span>
                    <span v-if="item.source == 'group' && item.specialFields.source == 'group_private'" class="text-size">Facebook Group Private</span>
                    <span v-if="item.beanType == 101 || item.beanType == 111"
                          class="text-size">{{ item.nameDomain }}</span>
                    <span v-if="item.beanType == 106" class="text-size">Youtube</span>
                    <span v-if="item.beanType == 113" class="text-size">Google</span>
                  </div>
                </div>
                <div>
                  <div class="vx-col md:w-1/6 w-full classification reaction-card-news"
                       v-if="item.beanType == 101 || item.beanType == 106 || item.beanType == 111 || item.beanType == 113">
                    <div class="vx-col mr-4 mt-3" style="float:right">
                      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                                  <span class="text-size">{{$t('articleDetail.contentMention')}}:
                                    <b v-if="item.classification == 1" style="color:rgba(39, 125, 246, 0.85)"
                                       class="text-size">{{$t('title.positive')}}</b>
                                    <b v-if="item.classification == -1" style="color:rgb(255,0,0)" class="text-size">{{$t('title.negative')}}</b>
                                    <b v-if="item.classification == 0" style="color:rgba(var(--vs-warning),1)"
                                       class="text-size">{{$t('title.neutral')}}</b>
                                    <!-- <b v-if="item.classification == 2" style="color:rgba(var(--vs-warning),1)">Chưa xác định</b> -->
                                  </span>
                        <feather-icon icon="ChevronDownIcon" style="vertical-align:middle;width:1rem"></feather-icon>
                        <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
                          <vs-dropdown-item @mousemove="backgroundHover">
                            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                                @click="updatePositive(item)">
                              <feather-icon icon="SmileIcon" svgClasses="w-4 h-4"
                                            style="color:green"/>
                              <span class="ml-2 text-size" style="vertical-align:middle">{{$t('title.positive')}}</span>
                            </li>

                            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                                @click="updateNegative(item)">
                              <feather-icon icon="FrownIcon" svgClasses="w-4 h-4" style="color:rgb(255,0,0)"/>
                              <span class="ml-2 text-size" style="vertical-align:middle;">{{$t('title.negative')}}</span>
                            </li>

                            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                                @click="updateInter(item)">
                              <feather-icon icon="MehIcon" svgClasses="w-4 h-4"/>
                              <span class="ml-2 text-size" style="vertical-align:middle">{{$t('title.neutral')}}</span>
                            </li>

                            <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="updateUndefined(item)">
                              <feather-icon icon="XCircleIcon" svgClasses="w-4 h-4" />
                              <span class="ml-2" style="vertical-align:middle">Chưa xác định</span>
                            </li> -->
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </div>


                  <div class="vx-col md:w-1/6 w-full classification-f"
                       v-if="item.beanType == 101 || item.beanType == 106 || item.beanType == 111 || item.beanType == 113"
                       @mouseover="mouseHoverClassification(item)" @mouseleave="mouseLeaveClassification(item)">
                    <div class="vx-row ml-4 mt-3 chart-classification">
                      <div class="blue-classification" style="width:9%;margin-right:1%"
                           v-for="value in item.optionalPositive">
                        <span>&nbsp;</span>
                      </div>
                      <div class="yellow-classification" style="width:9%;margin-right:1%"
                           v-for="value in item.optionalNeutral">
                        <span>&nbsp;</span>
                      </div>
                      <div class="red-classification" style="width:9%;margin-right:1%"
                           v-for="value in item.optionalNegative">
                        <span>&nbsp;</span>
                      </div>
                    </div>
                  </div>

                  <div :class="{'reaction-card classification-detail' :item.beanType == 101 || item.beanType == 106 || item.beanType == 111 || item.beanType == 113,
                            'reaction-card classification-fb' : item.beanType == 104 || item.beanType == 105}"
                       v-show="item.activeClassification">
                    <div class="vx-row">
                      <div class="vx-col md:w-1/3 w-full mt-2">
                        <div class="">
                          <span class="ml-4 text-size">{{$t('title.positive')}}</span>
                          <span rel="1" data:collapsed="false"
                                class="apexcharts-legend-marker ml-2 circle-classification-pos mb-1"></span>
                        </div>
                        <div class="">
                          <span class="pl-8"><b>{{ item.percentPositive || 0 }} %</b></span>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/3 w-full mt-2">
                        <div class="">
                          <span class="text-size">{{$t('title.neutral')}}</span>
                          <span data-v-7ac6448e="" rel="2" data:collapsed="false"
                                class="apexcharts-legend-marker ml-2 circle-classification-tl mb-1"></span>
                        </div>

                        <div class="">
                          <span class="ml-4"><b>{{ item.percentNeurtal || 0 }} %</b></span>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/3 w-full mt-2">
                        <div class="">
                          <span class="text-size">{{$t('title.negative')}}</span>
                          <span rel="3" data:collapsed="false"
                                class="apexcharts-legend-marker ml-2 circle-classification-nega mb-1"></span>
                        </div>
                        <div class="">
                          <span class="ml-4"><b>{{ item.percentNegative || 0 }} %</b></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row comment" style="padding-bottom: 0px !important;">
                <div style="width:14%;float:left; margin-right:10px;margin-bottom:10px;margin-left:-10px"
                     v-if="item.image !=null">

                  <div>

                  </div>
                  <img class="mt-2" @error="imgError" data-v-3e4a5c2c="" :src="item.image"
                       style="height: 6vw; width: 10vw">

                  <div class="mt-2">
                    <span class="facebook-name text-name text-size"
                          v-if="item.beanType == 106"><b>{{ item.titleYoutube }}</b></span>
                    <span class="facebook-name text-name text-size"
                          v-if="item.beanType == 111"><b>{{ item.userNameForum }}</b></span>
                    <span class="facebook-name text-name text-size" v-else><b>{{ item.name }}</b></span>
                  </div>

                  <div class="">
                    <span style="font-size:10px" class="text-size">{{ item.datePublish }}</span>
                  </div>
                </div>
                <div style="width:14%;float:left; margin-right:10px;margin-bottom:10px;margin-left:-10px" v-else>
                  <img class="mt-2" data-v-3e4a5c2c="" src="@/assets/images/logo/no_image.png"
                       style="height: 6vw;width: 10vw;">
                  <div class="mt-2">
                    <span class="facebook-name text-name text-size"
                          v-if="item.beanType == 106"><b>{{ item.titleYoutube }}</b></span>
                    <span class="facebook-name text-name text-size"
                          v-if="item.beanType == 111"><b>{{ item.userNameForum }}</b></span>
                    <span class="facebook-name text-name text-size" v-else><b>{{ item.name }}</b></span>
                  </div>
                  <div class="">
                    <span style="font-size:10px" class="text-size">{{ item.datePublish }}</span>
                  </div>
                </div>

                <div style="width:78%; margin-left:6%;height:auto;text-align:justify; display: block;">

                  <div class="vx-row">
                    <div class="reaction-card vx-col md:w-2/3 w-full pt-1 pl-2 ml-6"
                         v-if="item.beanType ==104 || item.beanType == 105"
                         style="margin:-15px 0px 10px 0px;background-color: rgba(236,242,249);width: 79.6667% !important">
                      <div class="vx-row pb-2">

                        <div class="vx-col md:w-1/6 text-reaction mt-2" @mouseover="mouseHoverClassification(item)"
                             @mouseleave="mouseLeaveClassification(item)">
                          <div class="vx-row pl-6 mt-3">
                            <div class="blue-classification" style="width:8%;margin-right:1%"
                                 v-for="value in item.optionalPositive">
                              <span>&nbsp;</span>
                            </div>
                            <div class="yellow-classification" style="width:8%;margin-right:1%"
                                 v-for="value in item.optionalNeutral">
                              <span>&nbsp;</span>
                            </div>
                            <div class="red-classification" style="width:8%;margin-right:1%"
                                 v-for="value in item.optionalNegative">
                              <span>&nbsp;</span>
                            </div>
                          </div>
                        </div>

                        <div class="vx-col md:w-1/6 text-reaction mt-2"
                             style="padding: 0; border-right: 1px solid #fff;">
                          <span class="text-size">{{$t('title.shades')}}</span>
                          <div class="w-full">
                            <vs-dropdown  vs-custom-content vs-trigger-click class="cursor-pointer ml-2">
                              <b v-if="item.classification == 1" style="color:rgba(39, 125, 246, 0.85)"
                                 class="text-size">{{$t('title.positive')}}</b>
                              <b v-if="item.classification == -1" style="color:rgb(255,0,0)" class="text-size">{{$t('title.negative')}}</b>
                              <b v-if="item.classification == 0" style="color:rgba(var(--vs-warning),1)"
                                 class="text-size">{{$t('title.neutral')}}</b>
                              <!-- <b v-if="item.classification == 2" style="color:rgba(var(--vs-warning),1)">Chưa xác định</b> -->
                              <feather-icon icon="ChevronDownIcon"
                                            style="vertical-align:middle;width:1rem"></feather-icon>
                              <vs-dropdown-menu class="vx-navbar-dropdown" style="width:150px;" >
                                <vs-dropdown-item @mousemove="backgroundHover">
                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                                      @click="updatePositive(item)">
                                    <feather-icon icon="SmileIcon" svgClasses="w-4 h-4"
                                                  style="color:green"/>
                                    <span class="ml-2 text-size" style="vertical-align:middle">{{$t('title.positive')}}</span>
                                  </li>

                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                                      @click="updateNegative(item)">
                                    <feather-icon icon="FrownIcon" svgClasses="w-4 h-4" style="color:rgb(255,0,0)"/>
                                    <span class="ml-2 text-size" style="vertical-align:middle;">{{$t('title.negative')}}</span>
                                  </li>

                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                                      @click="updateInter(item)">
                                    <feather-icon icon="MehIcon" svgClasses="w-4 h-4"/>
                                    <span class="ml-2 text-size" style="vertical-align:middle">{{$t('title.neutral')}}</span>
                                  </li>

                                  <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="updateUndefined(item)">
                                    <feather-icon icon="XCircleIcon" svgClasses="w-4 h-4" />
                                    <span class="ml-2" style="vertical-align:middle">Chưa xác định</span>
                                  </li> -->
                                </vs-dropdown-item>
                              </vs-dropdown-menu>
                            </vs-dropdown>
                          </div>
                        </div>
                        <!-- <div class="vx-col md:w-1/6 text-reaction mt-2">
                            <span><b>{{item.like}}</b></span>
                        </div> -->
                        <div class="vx-col md:w-1/6 text-reaction mt-2"
                             style="padding: 0;border-right: 1px solid #fff;">
                          <span><b>{{ item.comment }}</b></span>
                          <div class="w-full">
                            <span class="text-size">{{$t('articleDetail.commentFacebook')}}</span>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/6 text-reaction mt-2" style="padding: 0;">
                          <span><b>{{ item.share }}</b></span>
                          <div class="w-full">
                            <span class="text-size">{{$t('articleDetail.share')}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="vx-col md:w-1/3 w-full reaction-card pt-1"
                         v-if="item.beanType ==104 || item.beanType == 105" style="width: 16.33333% !important;"
                         @mouseover="mouseHover(item)" @mouseleave="mouseLeave(item)">
                      <div class="vx-row">
                        <div class="vx-col md:w-1/3 pl-4 pt-3">
                          <img class="mt-1" :src="item.highlightReaction.icon" alt="" style="width:2rem">
                        </div>
                        <div class="vx-col md:w-2/3 mt-2"
                             style="padding: 0;padding:0rem 0px 0px 0rem;text-align:center">
                          <span class="text-size"><b>{{ nFormatter(item.highlightReaction.value) || 0 }}</b></span>
                          <div class="reaction">
                            <span class="text-size">({{ item.highlightReaction.percent || 0 }}%)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="reaction-card reaction-detail" v-show="item.active">
                    <div class="vx-row pb-1">
                      <div class="vx-col md:w-1/3 w-full  mt-2 ml-2">
                        <div class="vx-row" style="border-right:1px solid #fff">
                          <div class="vx-col md:w-1/3 w-full pl-6">
                            <img :src="item.highlightReaction.icon" alt="" style="width:5rem">
                          </div>
                          <div class="vx-col md:w-2/3 w-full" style="padding:1rem 0px 0px 2rem">
                            <span class="text-size">{{ item.highlightReaction.label }}</span>
                            <div class="reaction">
                              <span
                                  class="text-size"><b>{{ nFormatter(item.highlightReaction.value) }}</b>({{ item.highlightReaction.percent || 0 }}%)</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/4 w-full mt-2 ml-2"
                           style="padding-right: 0px; width: 19.66667% !important">
                        <div class="vx-row pt-1"
                             style="border-right:1px solid #fff; display:flex; justify-content: center">
                          <div class=" pl-2">
                            <img :src="item.totalReaction[0].icon" alt="" style="width:2rem">
                          </div>

                          <div class="vx-col md:w-2/3 w-full pl-0 pt-1 pl-2">
                            <span
                                class="text-size"><b>{{ nFormatter(item.totalReaction[0].value) || 0 }}</b>({{ item.totalReaction[0].percent || 0 }}%)</span>
                          </div>
                        </div>

                        <div class="vx-row" style="border-right:1px solid #fff;  display:flex; justify-content: center">
                          <div class="pl-2">
                            <img :src="item.totalReaction[1].icon" alt="" style="width:2rem">
                          </div>

                          <div class="vx-col md:w-2/3 w-full pl-0 pt-1 pl-2">
                            <span
                                class="text-size"><b>{{ nFormatter(item.totalReaction[1].value) || 0 }}</b>({{ item.totalReaction[1].percent || 0 }}%)</span>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/4 w-full mt-2 ml-2"
                           style="padding-right: 0px;width: 19.66667% !important">
                        <div class="vx-row pt-1"
                             style="border-right:1px solid #fff; display:flex; justify-content: center">
                          <div class=" pl-2">
                            <img :src="item.totalReaction[2].icon" alt="" style="width:2rem;">
                          </div>

                          <div class="vx-col md:w-2/3 w-full pl-0 pt-1 pl-2">
                            <span
                                class="text-size"><b>{{ nFormatter(item.totalReaction[2].value) || 0 }}</b>({{ item.totalReaction[2].percent || 0 }}%)</span>
                          </div>
                        </div>
                        <div class="vx-row" style="border-right:1px solid #fff; display:flex; justify-content: center">
                          <div class=" pl-2">
                            <img :src="item.totalReaction[3].icon" alt="" style="width:2rem">
                          </div>

                          <div class="vx-col md:w-2/3 w-full pl-0 pt-1 pl-2">
                            <span
                                class="text-size"><b>{{ nFormatter(item.totalReaction[3].value) || 0 }}</b>({{ item.totalReaction[3].percent || 0 }}%)</span>
                          </div>
                        </div>
                      </div>

                      <div class="vx-col md:w-1/4 w-full mt-2 ml-2"
                           style="padding-right: 0px;width: 19.66667% !important">
                        <div class="vx-row pt-1" style=" display:flex; justify-content: center">
                          <div class=" pl-2">
                            <img :src="item.totalReaction[4].icon" alt="" style="width:2rem">
                          </div>

                          <div class="vx-col md:w-2/3 w-full pl-0 pt-1 pl-2">
                            <span
                                class="text-size"><b>{{ nFormatter(item.totalReaction[4].value) || 0 }}</b>({{ item.totalReaction[4].percent || 0 }}%)</span>
                          </div>
                        </div>

                        <div class="vx-row" style=" display:flex; justify-content: center">
                          <div class="pl-2">
                            <img :src="item.totalReaction[5].icon" alt="" style="width:2rem">
                          </div>

                          <div class="vx-col md:w-2/3 w-full pl-0 pt-1 pl-2">
                            <span
                                class="text-size"><b>{{ nFormatter(item.totalReaction[5].value) || 0 }}</b>({{ item.totalReaction[5].percent || 0 }}%)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <h6 data-v-3e4a5c2c=""
                      :class="{'item-name font-semibold mb-1 hover:text-primary cursor-pointer text-name ml-2 text-size' : item.beanType == 104 || item.beanType == 105, 'item-name font-semibold mb-1 hover:text-primary cursor-pointer text-name mt-4 ml-2 text-size' : item.beanType == 101 || item.beanType == 106  || item.beanType == 111 || item.beanType == 113}"
                      @click="openDialog(item)">
                    {{ item.title }}
                  </h6>
                  <p data-v-3e4a5c2c="" class="text-sm mb-4 cursor-pointer"></p>
                  <p v-html="item.displayFullContent" data-v-3e4a5c2c=""
                     :class="{'item-description text-sm text cursor-pointer ml-2 text-size' : item.beanType == 104 || item.beanType == 105, 'item-description text-sm text-news cursor-pointer ml-2 text-size' : item.beanType == 101 || item.beanType == 106  || item.beanType == 111 || item.beanType == 113}"
                     @click="openDialog(item)">
                  </p>
                  <div class="" style="padding-left:10px">
                    <div style="width:14%;float:left; margin-right:10px;margin-bottom:10px"></div>

                  </div>
                </div>
              </div>
              <div class="vx-row" style="padding-bottom: 0px !important;margin-top:-10px">
                <div style="width:100%; margin-left:5%;direction:rtl;" class="text">
                  <div class="w-full ">
                    <div style="margin-botton: 5px;float: right">

                      <div class="vx-col md:w-1/6 w-full">
                      </div>

                      <div class="copy-link cursor-pointer actives mt-2" :data-url=item.link @click="copyLink">
                        <a id="link" class="text-size">
                          <feather-icon icon="CopyIcon" style="vertical-align: bottom;width:15px"></feather-icon>
                          {{$t('articleDetail.copy')}}
                        </a>
                      </div>
                      <div class="link-content cursor-pointer actives mt-2" @click="directionNews(item)">
                        <a class="text-size">
                          <feather-icon icon="Link2Icon" style="vertical-align: bottom;width:15px"></feather-icon>
                          {{$t('articleDetail.origin')}}
                        </a>
                      </div>

                      <div class="spam cursor-pointer actives mt-2" @click="confirmSpam(item)">
                        <a id="link" class="text-size">
                          <feather-icon icon="TrashIcon" style="vertical-align: bottom;width:15px"></feather-icon>
                          {{$t('articleDetail.spam')}}
                        </a>
                      </div>

                      <div class="spam cursor-pointer actives mt-2" @click="updateBookmark(item)"
                           v-if="item.isBookmark == false">
                        <a id="link" class="text-size">
                          <feather-icon icon="BookmarkIcon" style="vertical-align: bottom;width:15px"></feather-icon>
                          {{$t('articleDetail.save')}}
                        </a>
                      </div>

                      <div class="spam cursor-pointer actives mt-2" @click="updateBookmark(item)" v-else>
                        <a id="link" class="text-size">
                          <feather-icon icon="StarIcon"
                                        style="vertical-align: bottom;width:15px;color:#ffb100"></feather-icon>
                          {{$t('articleDetail.unSavedChanges')}}
                        </a>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </vx-card>
          </div>

          <div class="vx-col md:w-1/3 w-full" v-if="showFilterCase == false">
            <div class="vx-row">
              <div class="vx-col w">
                <b class="title-size"> {{$t('articleDetail.filter')}}</b>
              </div>
              <div class="vx-col w-full mt-2">
                <!-- <vs-input
                id="myInput"
                style="width:100%"
                placeholder ="Tìm theo từ khóa..."
                data-vv-valuedate-on="blur"
                v-validate ="'required'"
                v-on:keydown.enter="searchByKeyword"
                v-model="formData.keyword"
                icon-pack="feather"
                icon="icon-search"
                ></vs-input> -->

                <vue-simple-suggest
                    v-model="formData.keyword"
                    :list="simpleSuggestionList.map(el => el.topicName)"
                    :placeholder=" $t('articleDetail.findByKeyword')"
                    data-vv-valuedate-on="blur"
                    v-validate="'required'"
                    @suggestion-click="searchByKeyword"
                    icon-pack="feather"
                    icon="icon-search"
                    :filter-by-query="true">
                </vue-simple-suggest>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col mt-2 w-full">
                <span class="text-size"> {{$t('title.time')}} </span>
                <date-range-picker
                    ref="picker"
                    :locale-data="{format: 'dd/mm/yyyy' }"
                    :opens="'left'"
                    @update="loadData"
                    v-model="dateRange">
                </date-range-picker>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full mt-2">
                <span class="text-size"> {{$t('articleDetail.sort')}}: </span>
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <span v-if="valueText" class="text-size"><b style="color:#277DF6">{{ valueText }}</b></span>
                  <span v-if="valueOldestPost" class="text-size"><b
                      style="color:#277DF6">{{ valueOldestPost }}</b></span>
                  <span v-if="valueInteractive" class="text-size"><b
                      style="color:#277DF6">{{ valueInteractive }}</b></span>
                  <span v-if="valueInteractiveUp" class="text-size"><b
                      style="color:#277DF6">{{ valueInteractiveUp }}</b></span>
                  <span v-if="valuePriorityLevel" class="text-size"><b
                  style="color:#277DF6">{{ valuePriorityLevel }}</b></span>
                  <feather-icon icon="ChevronDownIcon" style="vertical-align:middle;width:1rem"></feather-icon>
                  <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
                    <vs-dropdown-item @mousemove="backgroundHover">
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="clickNewPost">
                        <!-- <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4" /> -->
                        <span class="ml-2 text-size" style="vertical-align:middle"> {{$t('articleDetail.newsFeed')}}</span>
                      </li>

                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="clickPriceDown">
                        <!-- <feather-icon icon="GlobeIcon" svgClasses="w-4 h-4" /> -->
                        <span class="ml-2 text-size" style="vertical-align:middle">{{$t('articleDetail.newsOld')}}</span>
                      </li>
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="clickPriceUp">
                        <!-- <feather-icon icon="ArrowUpIcon" svgClasses="w-4 h-4" /> -->
                        <span class="ml-2 text-size" style="vertical-align:middle">{{$t('articleDetail.ascendingLevel')}}</span>
                      </li>

                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="clickDown">
                        <!-- <feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" /> -->
                        <span class="ml-2 text-size" style="vertical-align:middle">{{$t('articleDetail.decreaseLevel')}}</span>
                      </li>
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="clickPriorityLevvel">
                          <!-- <feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" /> -->
                          <span class="ml-2 text-size" style="vertical-align:middle">{{$t('articleDetail.priorityLevel')}}</span>
                      </li>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <span class="text-size">{{$t('title.shades')}}: </span>

                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <span v-if="valueTextAll" class="text-size"><b style="color:#277DF6">{{ valueTextAll }}</b></span>
                  <span v-if="valueTextPositive" class="text-size"><b style="color:#277DF6">{{ valueTextPositive }}</b></span>
                  <span v-if="valueTextNegative" class="text-size"><b style="color:#277DF6">{{ valueTextNegative }}</b></span>
                  <span v-if="valueTextInter" class="text-size"><b style="color:#277DF6">{{ valueTextInter }}</b></span>
                  <span v-if="valueTextUndefined" class="text-size"><b
                      style="color:#277DF6">{{ valueTextUndefined }}</b></span>
                  <feather-icon icon="ChevronDownIcon" style="vertical-align:middle;width:1rem"></feather-icon>
                  <vs-dropdown-menu class="vx-navbar-dropdown" style="width:200px;">
                    <vs-dropdown-item @mousemove="backgroundHover">
                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="getListFacebook">
                        <feather-icon icon="CircleIcon" style="width:1rem"/>
                        <span class="ml-2 text-size" style="vertical-align:middle">{{$t('articleDetail.all')}}</span>
                      </li>

                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="checkedClassificationPositive">
                        <feather-icon icon="SmileIcon" svgClasses="w-4 h-4" style="color:green"/>
                        <span class="ml-2 text-size" style="vertical-align:middle">{{$t('title.positive')}}</span>
                      </li>

                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="checkedClassificationNegative">
                        <feather-icon icon="FrownIcon" svgClasses="w-4 h-4" style="color:rgb(255,0,0)"/>
                        <span class="ml-2 text-size" style="vertical-align:middle;">{{$t('title.negative')}}</span>
                      </li>

                      <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                          @click="checkedClassificationInter">
                        <feather-icon icon="MehIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2 text-size" style="vertical-align:middle">{{$t('title.neutral')}}</span>
                      </li>

                      <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="checkedClassificationUndefined">
                        <feather-icon icon="XCircleIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2" style="vertical-align:middle">Chưa xác định</span>
                      </li> -->
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <span class="text-size"> {{$t('articleDetail.filterByFeeling')}}: </span>
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <img :src="iconFilter" alt="" style="width:2rem;vertical-align: middle;" class="mr-2 ml-1">
                  <span v-if="valueText" class="text-size"><b style="color:#277DF6">{{ labelReaction }}</b></span>
                  <feather-icon icon="ChevronDownIcon" style="vertical-align:middle;width:1rem"></feather-icon>
                  <vs-dropdown-menu class="vx-navbar-dropdown" style="width:16rem;" >
                      <vs-dropdown-item @mousemove="backgroundHover">
                      <ul v-for="(item,index) of reactionItem" :key="index">
                        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text"
                            @click="searchByReaction(item)">
                          <img :src="item.icon" alt="" style="width:2rem">
                          <span class="ml-2 mt-2 text-size" style="vertical-align:middle">{{ item.label }}</span>
                        </li>
                        </ul>
                      </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

            </div>

            <div class="vx-row">
              <div class="vx-col md:w-1/12 w-full mt-2" style="max-width:60px">
                <span class="text-size">{{$t('articleDetail.source')}}: </span>
              </div>
            </div>

            <div class="vx-row">

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px">
                <label
                    :class="{'cursor-pointer article-news text-size': findAll == false,'active cursor-pointer text-size':findAll == true}"
                    @click="getAllData">{{$t('articleDetail.all')}}</label>
              </div>

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min cursor-pointer" style="margin-right:10px"
                   v-if="showFacebookProfile == true">
                <label
                    :class="{'cursor-pointer article-news text-size': facePostCheckBox == false,'active cursor-pointer text-size':facePostCheckBox == true}"
                    @click="articleChangeFacePost">{{$t('articleDetail.postFacebook')}}</label>
              </div>

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                   v-if="showFacebookComment == true">
                <label
                    :class="{'cursor-pointer article-news text-size': faceCommentCheckBox == false,'active cursor-pointer text-size':faceCommentCheckBox == true}"
                    @click="articleChangeFaceComment">{{$t('articleDetail.commentFacebook')}}</label>
              </div>

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                   v-if="showNewsPost == true">
                <label
                    :class="{'cursor-pointer article-news text-size': newsPostCheckBox == false,'active cursor-pointer text-size':newsPostCheckBox == true}"
                    @click="articleChangeNews">{{$t('articleDetail.news')}}</label>
              </div>

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                   v-if="showYoutube == true">
                <label
                    :class="{'cursor-pointer article-news text-size': youtubeCheckBox == false,'active cursor-pointer text-size':youtubeCheckBox == true}"
                    @click="articleChangeYoutube">Youtube</label>
              </div>

              <!-- <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-if="showYoutubeComment == true">
                  <label :class="{'cursor-pointer article-news': youtubeCheckBoxComment == false,'active cursor-pointer':youtubeCheckBoxComment == true}" @click="articleChangeYoutubeComment">Bình luận Youtube</label>
              </div> -->

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-if="showForum == true">
                <label
                    :class="{'cursor-pointer article-news text-size': forumCheckbox == false,'active cursor-pointer text-size':forumCheckbox == true}"
                    @click="articleChangeForum">Forum</label>
              </div>

              <!-- <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-if="showForumComment == true">
                  <label :class="{'cursor-pointer article-news': forumCheckboxComment == false,'active cursor-pointer':forumCheckboxComment == true}" @click="articleChangeForumComment">Bình luận Forum</label>
              </div> -->

              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px"
                   v-if="showGoogle == true">
                <label
                    :class="{'cursor-pointer article-news text-size': googleCheckbox == false,'active cursor-pointer text-size':googleCheckbox == true}"
                    @click="articleChangeGoogle">Google</label>
              </div>
              <div class="vx-col md:w-1/12 w-full mt-2 checkbox-min" style="margin-right:10px" v-for="(source,indexSource) in sourceData" :key="indexSource">
                  <label :class="{'cursor-pointer article-news text-size': source.checked == false ,'active cursor-pointer text-size' : source.checked == true}" @click="articleChangeOther(source,indexSource)"> {{source.name}} </label>
              </div>
            </div>
          </div>
        </div>
      </template>

      <vs-popup :title="dialogName" :active.sync="popupActive">
        <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0 mb-10"
                             :settings="settings" style="max-height: 36rem" >
          <div class="vx-col w-full mt-2" style="height:80%">
            <span class="facebook-name text-size" ><b>{{ formData.name }}</b></span>
            <div class="">
              <span style="font-size:10px;margin-left:2%" class="text-size">{{ formData.datePublish }}</span>
            </div>
            <div class="vx-row comment">
              <div class="content-popup" v-if="formData.img !=null" style="text-align:center">
                <img data-v-3e4a5c2c="" @error="imgError" :src="formData.img" style="width:25rem;height:18rem">
              </div>
              <div class="content-popup" v-else style="text-align:justify;margin-right: 0px; ">
                <img data-v-3e4a5c2c="" src="@/assets/images/logo/no_image.png" style="width:25rem;height:18rem">
              </div>
              <div class="content-popup">
                <h6 data-v-3e4a5c2c="" class="item-name font-semibold mb-1 hover:text-primary cursor-pointer text-size">
                  {{ formData.title }}</h6>
                <p data-v-3e4a5c2c="" class="text-sm mb-4">
                </p>
                <p v-html="formData.fullContents" data-v-3e4a5c2c="" class="item-description text-sm inline text-size">
                </p>

              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
        <div class="vx-col w-full mt-2 modal-footer" style="heigh:10%;border-top: 1px solid #ccc">
          <div class="link-post cursor-pointer">
            <a target="_blank" :href="formData.url" class="text-size">{{$t('articleDetail.findOrigin')}}
              <feather-icon icon="Link2Icon" class="vertical-icon" style="width:15px"></feather-icon>
            </a>
          </div>
        </div>

      </vs-popup>
      <div class="vx-col md:w-2/3 w-full mt-2">
        <vs-pagination
            :total="totalPages"
            :max="maxPageNumbers"
            v-model="currentPage"
            :per-page="perPage"
            @change="onChangePage"
        ></vs-pagination>
      </div>
      <!-- PAGINATION -->
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import NoImage from '@/assets/images/logo/no_image.png';
import emoji from '@/assets/images/icon-facebook/emoji.png';
import like from '@/assets/images/icon-facebook/like.png';
import love from '@/assets/images/icon-facebook/love.png';
import care from '@/assets/images/icon-facebook/care.png';
import haha from '@/assets/images/icon-facebook/haha.png';
import wow from '@/assets/images/icon-facebook/wow.png';
import sad from '@/assets/images/icon-facebook/sad.png';
import angry from '@/assets/images/icon-facebook/angry-face.png';
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    vSelect,
    Datepicker,
    NoImage,
    DateRangePicker,
    VueSimpleSuggest,
    VuePerfectScrollbar
  },
  props: {
    initial: {
      default: true
    },
    dateRange: {
      type: Object
    },
    fromDate: {} ,
    toDate : {},
    //hide and show article
    showFacebookProfile: {default: true},
    showFacebookComment: {default: true},
    showNewsPost: {default: true},
    showTopic: {default: true},
    topicId: {},
    selectedTopic: {},
    classification: {default: null},
    facePost: {},
    faceComment: {},
    newsPost: {},
    getAll: {default: true},
    labelNews: {default: false},
    labelSocial: {default: false},
    showNewsPostDetail: {default: false},
    showFilterCase: {default: false},
    refreshData: {default: 0},
    showYoutube: {default: true},
    showYoutubeComment: {default: true},
    showForum: {default: true},
    showForumComment: {default: true},
    showGoogle: {default: true}
  },

  data() {
    return {
      sourceData: [],
      simpleSuggestionList: [],
      loadDataNofity: 0,
      pageNumber: 0,
      panel: 'range',
      topic: null,
      optionalsTopic: [],
      userTopics: [],
      optionalsTopics: [
        {text: 'Tin tức', value: 0, checked: false},
        {text: 'Thể thao', value: 1, checked: false},
        {text: 'Website', value: 2, checked: false},
        {text: 'Blog', value: 3, checked: false}
      ],
      valueText: null,
      valueOldestPost: null,
      valueInteractive: null,
      valueInteractiveUp: null,
      radio: "SmileIcon",
      date: null,
      optionalsValue: "Tất cả chủ đề",
      checkbox: false,
      valueCheckbox: [],
      searchByIdAndName: null,
      currentItemView: 'item-list-view',
      checkBox: false,
      rowDatas: [],
      pageNumbers: null,
      pageSize: null,
      totalPages: 0,
      perPage: 10,
      maxPageNumbers: 6,
      lastPage: 1,
      currentPage: 1,
      gridApi: null,

      popupActive: false,

      dialogName: null,
      titleDialog: null,

      bookmark: true,
      star: false,

      valueRadio: null,

      filter: true,

      responseDataTopic: [],
      topicName: null,
      rangeDate: null,
      formData: {
        url: null,
        title: null,
        fullContents: null,
        datePublish: null,
        name: null,
        img: null,
        keyword: null,
        fromDate: null,
        toDate: null
      },
      userName: [],
      totalElements: null,
      beanType: null,

      // checkbox
      dataCheckBox: false,
      dataCheckBox2: false,
      dataCheckBox3: false,
      valueCheckBoxClassification: null,
      pooledNews: null,
      newsPostCheckBox: false,
      facePostCheckBox: false,
      faceCommentCheckBox: false,
      findAll: false,
      youtubeCheckBox: false,
      youtubeCheckBoxComment: false,
      forumCheckbox: false,
      forumCheckboxComment: false,
      googleCheckbox: false,
      otherCheckbox:[],
      otherCheckboxFacebook:[],
      checkIndexOther:null,

      //Date
      dateNow: null,

      //value text classification
      valueTextPositive: null,
      valueTextNegative: null,
      valueTextInter: null,
      valueTextAll: null,
      valueTextUndefined: null,
      valuePriorityLevel: null,

      offset: null,
      pageSize: null,
      totalContent: 0,

      //classification
      item: null,
      origin: null,
      spam: false,

      //Spam
      itemSpam: null,
      News: false,
      Social: false,

      //hover
      active: false,
      reactionItem: [
        {text: 'all', icon: emoji, label: this.$t('articleBookmark.all')},
        {text: 'like', icon: like, label: this.$t('articleBookmark.like')},
        {text: 'love', icon: love, label: this.$t('articleBookmark.love')},
        {text: 'haha', icon: haha, label: 'Haha'},
        {text: 'wow', icon: wow, label: this.$t('articleBookmark.wow')},
        {text: 'care', icon: care, label: this.$t('articleBookmark.care')},
        {text: 'sad', icon: sad, label: this.$t('articleBookmark.sad')},
        {text: 'angry', icon: angry, label: this.$t('articleBookmark.angry')}
      ],
      labelReaction: this.$t('articleBookmark.all'),
      selectedAngry: null,
      selectedCare: null,
      selectedHaha: null,
      selectedLike: null,
      selectedLove: null,
      selectedSad: null,
      selectedWow: null,
      iconFilter: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .30,
        suppressScrollX: true
      },

    }
  },
  filters: {
    date(val) {
      return val ? moment(val).format('DD/MM/YYYY') : ''
    },
  },
  watch: {
    refreshData: function (newVal, oldVal) {
      this.currentPage = 1;
      this.loadData();
    }
  },
  computed: {
    topicSelected: {
      get() {
        let label = null;
        let object = this.optionalsTopic.find(el => el.value === this.topicName);
        if (!object) {
          return null
        }

        if (object && object.label.length > 13) {
          label = object.label.slice(0, 13) + '...';
        } else {
          label = object.label;
        }

        return {
          label: label,
          value: this.topicName
        }
      },
      set(object) {
        if (!object) {
          this.topicName = null;
        } else {
          this.topicName = object.value
        }
      }
    },
  },
  methods: {
    backgroundHover: function(){
      document.getElementsByClassName('vs-component vs-dropdown--item')[0].style.background='#fff';
    },
    getDataSource: function(){
        const payload = {
          pageNumber: 0,
          pageSize: 20
        }
        this.$processor.post('website/get-all', payload).then((response) => {
          this.sourceData = response.data.content;
          this.sourceData.forEach(el => el.checked = false);
          this.sourceData = this.sourceData.filter(el => el.activeWebsite == true)
        })
    },
    directionNews: function (event) {
      window.open(event.link, "_blank");
    },
    validURL: function (str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return !!pattern.test(str);
    },
    imgError(image) {
      image.target.src = NoImage;
    },
    highlight: function (text) {
      let inputText = document.getElementById("inputText");
      let innerHTML = inputText.innerHTML;
      let index = innerHTML.indexOf(text);
      if (index >= 0) {
        innerHTML = innerHTML.substring(0, index) + "<span class ='highlight'>" + innerHTML.substring(index, index + text.length) + "</span>" + innerHTML.substring(index + text.length);
        inputText.innerHTML = innerHTML;
      }
    },

    // Facebook-API

    articleChangeFacePost: function () {
      if (this.facePostCheckBox) {
        this.facePostCheckBox = false;
      } else {
        this.facePostCheckBox = true;
        this.findAll = false;
        this.currentPage = 1;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();


    },
    articleChangeFaceComment: function () {
      if (this.faceCommentCheckBox) {
        this.faceCommentCheckBox = false;
      } else {
        this.faceCommentCheckBox = true;
        this.findAll = false;
        this.currentPage = 1
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeNews: function () {
      if (this.newsPostCheckBox) {
        this.newsPostCheckBox = false;
      } else {
        this.newsPostCheckBox = true;
        this.findAll = false;
        this.currentPage = 1
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeYoutube: function () {
      if (this.youtubeCheckBox) {
        this.youtubeCheckBox = false;
      } else {
        this.youtubeCheckBox = true;
        this.findAll = false;
        this.currentPage = 1;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeYoutubeComment: function () {
      if (this.youtubeCheckBoxComment) {
        this.youtubeCheckBoxComment = false;
      } else {
        this.youtubeCheckBoxComment = true;
        this.findAll = false;
        this.currentPage = 1;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeForum: function () {
      if (this.forumCheckbox) {
        this.forumCheckbox = false;
      } else {
        this.forumCheckbox = true;
        this.findAll = false;
        this.currentPage = 1;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeForumComment: function () {
      if (this.forumCheckboxComment) {
        this.forumCheckboxComment = false;
      } else {
        this.forumCheckboxComment = true;
        this.findAll = false;
        this.currentPage = 1;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },

    articleChangeGoogle: function () {
      if (this.googleCheckbox) {
        this.googleCheckbox = false;
      } else {
        this.googleCheckbox = true;
        this.findAll = false;
        this.currentPage = 1;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox) {
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    getAllData: function () {
      this.$vs.loading();
      this.facePostCheckBox = false;
      this.faceCommentCheckBox = false;
      this.newsPostCheckBox = false;
      this.youtubeCheckBox = false;
      this.youtubeCheckBoxComment = false;
      this.forumCheckbox = false;
      this.forumCheckboxComment = false;
      this.googleCheckbox = false;
      this.findAll = true;
      this.currentPage = 1;
      this.sourceData.forEach(el => el.checked = false);
      this.otherCheckbox = [],
      this.otherCheckboxFacebook = [],
      this.checkIndexOther = null
      this.getListFacebook();
    },
    articleChangeGoogle: function(){
        if(this.googleCheckbox){
          this.googleCheckbox = false;
        }
        else{
          this.googleCheckbox = true;
          this.findAll = false;
          this.currentPage  = 1;
        }
        if(!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox  && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox && this.otherCheckbox.length == 0 && this.otherCheckboxFacebook == 0){
          this.findAll = true;
        }
        this.$vs.loading();
        this.loadData();
      },

      articleChangeOther: function(event, index){
        const resultDomain = event.url.split('//').pop().split('wwww.').pop().split('/', 1).pop();
        let indexItem = this.otherCheckbox.indexOf(resultDomain);
        if(event.checked){
          if(indexItem !== -1){
            this.otherCheckbox.splice(indexItem , 1);
          }
          event.checked = false;
        }
        else{
          this.otherCheckbox.push(resultDomain)
          event.checked = true;
          this.findAll = false;
          this.currentPage = 1;
        }
        if(!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox  && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckbox && this.otherCheckbox.length == 0){
          this.findAll = true;
        }
        this.$vs.loading();
        this.loadData();
    },
    loadData: function () {
      this.$vs.loading();
      let payload = {
        pageNumber: this.pageNumber,
        pageSize: 10,
        userDataElasticsearch: {classification: this.classification, topicId: this.topicId ? this.topicId : null, isSpam:false},
        recently: this.valueText,
        oldestPost: this.valueOldestPost,
        interactive: this.valueInteractive,
        interactiveAscending: this.valueInteractiveUp,
        priorityLevel: this.valuePriorityLevel,
        newsPost: this.newsPostCheckBox ? 101 : 0,
        facePost: this.facePostCheckBox ? 104 : 0,
        faceComment: this.faceCommentCheckBox ? 105 : 0,
        youtube: this.youtubeCheckBox ? 106 : 0,
        youtubeComment: this.youtubeCheckBox ? 107 : 0,
        forum: this.forumCheckbox ? 111 : 0,
        forumComment: this.forumCheckbox ? 112 : 0,
        google: this.googleCheckbox ? 113 : 0,
        domain: this.otherCheckbox,
        domainFacebook: [],
        fromDate: new Date(this.dateRange.startDate.setHours(0, 0, 0)),
        toDate: new Date(this.dateRange.endDate.setHours(23, 59, 59)),
        content: this.formData.keyword,
        hahaCount: this.selectedHaha,
        likeCount: this.selectedLike,
        loveCount: this.selectedLove,
        sadCount: this.selectedSad,
        wowCount: this.selectedWow,
        careCount: this.selectedCare,
        angryCount: this.selectedAngry,
        positive: true,
        negative: true,
        neutral: false
      }

      if (!payload.newsPost && !payload.facePost && !payload.faceComment && !payload.youtube && !payload.youtubeComment && !payload.forum && !payload.forumComment && !payload.google) {
        if (this.showFacebookProfile != "false") payload.facePost = 104
        if (this.showFacebookComment != "false") payload.faceComment = 105
        if (this.showNewsPost != "false") payload.newsPost = 101
        if (this.showYoutube != 'false') {
          payload.youtube = 106;
          payload.youtubeComment = 107
        }
        // if(this.showYoutubeComment != 'false') payload.youtubeComment  = 107
        if (this.showForum != 'false') {
          payload.forum = 111;
          payload.forumComment = 112
        }
        // if(this.showForumComment != 'false') payload.forumComment =  112
        if (this.showGoogle != false) payload.google = 113
      }

      // if (!(payload.recently || payload.oldestPost || payload.interactive)) return;
      // this.rowDatas = []
      this.$processor.post('/user-data/find-by-condition', payload).then(response => {
        this.$vs.loading.close();
        this.rowDatas = response.data.content.map(el => {
          if (el.domain) {
            let name = el.domain.split("//").pop().replace("www.", "");
            if (name.length > 15) {
              el.nameDomain = name.slice(0, 15) + '...';
            } else {
              el.nameDomain = name;
            }
          }
          // if(this.topicSelected.keywords){
          //   let data = this.topicSelected.keywords;
          //   data.forEach(topic =>{
          //     el.keywords = topic.keyword;
          //   })
          // }
          if (el.publishDate) {
            el.datePublish = moment(el.publishDate).format("DD/MM/YYYY HH:mm");
          }
          if (el.fullContents && el.fullContents.length > 0) {
            el.displayFullContent = el.fullContents.filter(item => item.type == "text").map((elements) => {
              if (elements.content) {
                return elements.content.trim();
              }
            }).join("\n");
          }
          el.displayFullContentOrigin = el.displayFullContent || "";
          if (el.url) {
            el.link = el.url;
          }
          if (el.specialFields.from) {
            let username = JSON.parse(el.specialFields.from);
            el.name = username.name;
          }
          if (el.attachmentUrls && el.attachmentUrls.length > 0) {
            let attachmentUrl = el.attachmentUrls[0];
            el.image = attachmentUrl.url;
          }
          if (el.specialFields.reactionCount >= 0) {
            el.reaction = el.specialFields.reactionCount;
          }
          if (el.specialFields.likeCount >= 0 && el.reaction > 0) {
            el.like = el.specialFields.likeCount;
            el.like_percent = (el.like / el.reaction * 100).toFixed(1)
          }
          if (el.specialFields.commentCount >= 0) {
            el.comment = el.specialFields.commentCount;
          }
          if (el.specialFields.shareCount >= 0) {
            el.share = el.specialFields.shareCount;
          }
          if (el.specialFields.commentCount >= 0) {
            el.commentWebsite = el.specialFields.commentCount;
          }
          if (el.specialFields.hahaCount >= 0 && el.reaction > 0) {
            el.haha = el.specialFields.hahaCount;
            el.haha_percent = (el.haha / el.reaction * 100).toFixed(1);
          }
          if (el.specialFields.angryCount >= 0 && el.reaction > 0) {
            el.angry = el.specialFields.angryCount;
            el.angry_percent = (el.angry / el.reaction * 100).toFixed(1);
          }
          if (el.specialFields.loveCount >= 0 && el.reaction > 0) {
            el.love = el.specialFields.loveCount;
            el.love_percent = (el.love / el.reaction * 100).toFixed(1);
          }
          if (el.specialFields.sadCount >= 0 && el.reaction > 0) {
            el.sad = el.specialFields.sadCount;
            el.sad_percent = (el.sad / el.reaction * 100).toFixed(1)
          }
          if (el.specialFields.careCount >= 0 && el.reaction > 0) {
            el.care = el.specialFields.careCount;
            el.care_percent = (el.care / el.reaction * 100).toFixed(1);
          }
          if (el.specialFields.wowCount >= 0 && el.reaction > 0) {
            el.wow = el.specialFields.wowCount;
            el.wow_percent = (el.wow / el.reaction * 100).toFixed(1)
          }
          if (el.specialFields.author) {
            el.name = el.specialFields.author.trim();
          }
          if (el.beanType) {
            this.beanType = el.beanType;
          }
          if (el.specialFields && el.specialFields.channel_title) {
            el.titleYoutube = el.specialFields.channel_title;
          }
          if (el.specialFields && el.specialFields.from) {
            let name = JSON.parse(el.specialFields.from);
            el.userNameForum = name.author;
          }
          if (el.negative && el.normal && el.positive) {
            const total = el.positive + el.negative + el.normal;
            el.percentPositive = (el.positive / total * 100).toFixed(0);
            el.percentNegative = (el.negative / total * 100).toFixed(0);
            el.percentNeurtal = (el.normal / total * 100).toFixed(0);

            const arr = [];
            const result = (el.positive / total * 10).toFixed(0);
            for (let i = 0; i < result; i++) {
              arr.push(i);
            }
            el.optionalPositive = arr;

            const arrNeutral = [];
            const resultNeutral = (el.normal / total * 10).toFixed(0);
            for (let i = 0; i < resultNeutral; i++) {
              arrNeutral.push(i);
            }
            el.optionalNeutral = arrNeutral;

            const arrNegative = [];
            const resultNegative = 10 - (arr.length + arrNeutral.length);
            for (let i = 0; i < resultNegative; i++) {
              arrNegative.push(i);
            }
            el.optionalNegative = arrNegative
          } else {
            const arr = [];
            const result = 10;
            for (let i = 0; i < result; i++) {
              arr.push(i);
            }
            if (el.classification == 0) {
              el.optionalNeutral = arr;
            } else if (el.classification == 1) {
              el.optionalPositive = arr;
            } else if (el.classification == -1) {
              el.optionalNegative = arr;
            }
          }

          let totalReaction = [
            {text: 'all', value: el.like, icon: like, label: 'Tất cả', percent: el.like_percent},
            {text: 'like', value: el.like, icon: like, label: 'Thích', percent: el.like_percent},
            {text: 'love', value: el.love, icon: love, label: 'Yêu thích', percent: el.love_percent},
            {text: 'haha', value: el.haha, icon: haha, label: 'Haha', percent: el.haha_percent},
            {text: 'wow', value: el.wow, icon: wow, label: 'Ngạc nhiên', percent: el.wow_percent},
            {text: 'care', value: el.care, icon: care, label: 'Thương thương', percent: el.care_percent},
            {text: 'sad', value: el.sad, icon: sad, label: 'Buồn', percent: el.sad_percent},
            {text: 'angry', value: el.angry, icon: angry, label: 'Phẫn nộ', percent: el.angry_percent}];
          const filter = totalReaction.sort(function (a, b) {
            return a.value - b.value
          });
          this.totalReaction = totalReaction;
          el.highlightReaction = filter[6];
          if (!el.highlightReaction.value) {
            el.highlightReaction = totalReaction[0];
          }
          totalReaction = totalReaction.filter(item => item.text != el.highlightReaction.text);
          el.totalReaction = totalReaction;

          if (el.specialFields.source) {
            el.source = el.specialFields.source;
          }
          if (el.specialFields.source && el.specialFields.source.includes('group')) {
            el.source = 'group'
          }
          if (el.displayFullContent) {
            el.origin = el.displayFullContent;
            const listTopic = this.userTopics;
            this.changeClassificationColor(this.userTopics, el);
          }
          el.active = false;
          el.activeClassification = false;
          return el;
        });
        this.totalPages = parseInt(response.data.totalPages, 10);
        this.totalElements = response.data.totalElements;
        // this.pageNumbers = response.data.pageable.pageNumber;
        // this.offset = response.data.pageable.offset;
        this.totalContent = (this.pageNumber + 1) * this.perPage;
        if (this.totalElements == 0) {
          this.totalContent = 0;
        }
        if (this.totalElements < 10) {
          this.totalContent = this.totalElements;
        }
        if (this.totalContent > this.totalElements) {
          this.totalContent = this.totalElements;
        }
        this.$vs.loading.close();
      }).catch(() => {
        this.$vs.loading.close();
      })
    },
    onGridReady() {
      if (this.$store.state.windowWidth <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }
      if (this.$store.state.windowWidth > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    clickNewPost: function () {
      this.valueText =  this.$t('articleDetail.newsFeed')
      this.valueOldestPost = null;
      this.valueInteractive = null;
      this.valueInteractiveUp = null;
      this.valuePriorityLevel = null;
      this.getListFacebook();
    },
    clickPriceDown: function () {
      this.$vs.loading();
      this.valueOldestPost =  this.$t('articleDetail.newsOld')
      this.valueText = null;
      this.valueInteractive = null;
      this.valueInteractiveUp = null;
      this.valuePriorityLevel = null;
      this.loadData()
    },
    clickPriorityLevvel: function(){
      this.valueText = null;
      this.valueOldestPost = null;
      this.valueInteractive = null;
      this.valueInteractiveUp = null;
      this.valuePriorityLevel = 'Mức độ ưu tiên';
      this.loadData();
    },
    clickDown: function () {
      this.$vs.loading();
      this.valueInteractive = this.$t('articleDetail.decreaseLevel');
      this.valueText = null;
      this.valueOldestPost = null;
      this.valueInteractiveUp = null;
      this.valuePriorityLevel = null;
      this.loadData();
    },
    clickPriceUp: function () {
      this.$vs.loading();
      this.valueInteractiveUp = this.$t('articleDetail.ascendingLevel');
      this.valueText = null;
      this.valueOldestPost = null;
      this.valueInteractive = null;
      this.loadData();
    },
    reportSpam: function () {
      this.popupActive = false;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('articleBookmark.titleTick'),
        text: this.$t('articleBookmark.textTick'),
        accept: this.deleteRecord,
        cancel: this.deleteRecord,
        acceptText: this.$t('articleBookmark.acceptText'),
        cancelText: this.$t('articleBookmark.cancelText')
      })
    },
    reportSpamForm: function () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('articleBookmark.titleTick'),
        text: this.$t('articleBookmark.textTick'),
        accept: this.confirmDialog,
        cancel: this.confirmDialog,
        acceptText: this.$t('articleBookmark.acceptText'),
        cancelText: this.$t('articleBookmark.cancelText')
      })
    },

    deleteRecord: function () {
      this.popupActive = true
    },
    getValueCheckbox: function () {
      let value = this.optionalsTopics.filter(item => item.checked).map(el => el.value);
      this.valueCheckbox = value;
    },
    onChangePage: function (event) {
      if (this.currentPage == this.lastPage) return;
      this.lastPage = event;
      this.$vs.loading();
      this.pageNumber = parseInt(event) - 1;
      this.loadData();
      this.$vs.loading.close();
    },
    openDialog: function (item) {
      if (this.formData.img) {
        this.formData.img = null;
      }
      this.popupActive = true;
      this.formData.title = item.title;
      if (item.specialFields && item.specialFields.from) {
        let data = JSON.parse(item.specialFields.from);
        this.formData.name = data.name;
      }
      if (item.specialFields.author) {
        this.formData.name = item.specialFields.author
      }
      // if (item.specialFields && item.specialFields.from) {
      //   const name = JSON.parse(item.specialFields.from);
      //   this.formData.name = name.author;
      // }
      if (item.specialFields && item.specialFields.channel_title) {
        this.formData.name = item.specialFields.channel_title;
      }
      if (item.url) {
        this.formData.url = item.link;
      }
      this.formData.fullContents = item.displayFullContentOrigin;

      this.formData.datePublish = moment(item.publishDate.replace('Z', '')).format("DD/MM/YYYY HH:mm");
      if (item.attachmentUrls.length > 0) {
        let img = item.attachmentUrls[0];
        this.formData.img = img.url;
      }

      setTimeout(()=>{
        this.$refs.scrollDialog.$el.scrollTop = 0;
      }, 100);
    },
    changeStar: function () {
      this.bookmark = false;
      this.star = true;
    },
    changeBookmark: function () {
      this.bookmark = true;
      this.star = false;
    },
    getValueRadio: function (value) {
      switch (value) {
        case 'SmileIcon':
          return this.valueRadio = 0;
      }
    },
    getListFacebook: function () {
      this.valueTextAll = this.$t('articleBookmark.all')
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueTextInter = null;
      this.classification = null;
      this.$vs.loading();
      this.loadData();

    },
    hideFilter: function () {
      this.filter = false;
    },
    showFilter: function () {
      this.filter = true;
    },
    checkedClassificationPositive: function () {
      this.$vs.loading();
      this.valueTextPositive = this.$t('articleBookmark.positive');
      this.valueTextAll = null;
      this.valueTextNegative = null;
      this.valueTextInter = null;
      this.valueTextUndefined = null;
      this.classification = 1;
      this.currentPage = 1;
      this.loadData();
      this.$vs.loading.close();

    },
    checkedClassificationNegative: function () {
      this.$vs.loading();
      this.valueTextNegative = this.$t('articleBookmark.negative');
      this.valueTextAll = null;
      this.valueTextPositive = null;
      this.valueTextInter = null;
      this.valueTextUndefined = null;
      this.classification = -1;
      this.currentPage = 1;
      this.loadData();
      this.$vs.loading.close();

    },
    checkedClassificationInter: function () {
      this.$vs.loading();
      this.valueTextInter = this.$t('articleBookmark.neutral');
      this.valueTextAll = null;
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueTextUndefined = null;
      this.classification = 0;
      this.currentPage = 1;
      this.loadData();
      this.$vs.loading.close();

    },
    checkedClassificationUndefined: function () {
      this.$vs.loading();
      // this.valueTextUndefined = "Chưa xác định";
      this.valueTextAll = null;
      this.valueTextPositive = null;
      this.valueTextPositive = null;
      this.valueTextInter = null;
      this.classification = 2;
      this.currentPage = 1;
      this.loadData();
      this.$vs.loading.close();
    },
    pooledNewsChecked: function () {
      this.$vs.loading();
      this.valueText = this.$t('articleDetail.newsFeed')
      this.valueOldestPost = null;
      this.valueInteractive = null
      this.loadData();
      this.$vs.loading.close();

    },

    searchByIdAndNameInput: function () {
      if (!this.searchByIdAndName) {
        this.getListFacebook();
      } else {
        const payload = {
          uid: this.searchByIdAndName
        };
        this.$processor.post('/facebook-queue/find-by-id', payload).then((response) => {
          this.rowDatas = response.data;
          if (this.rowDatas) {
            this.rowDatas.forEach(element => {
              let details = JSON.parse(element.details);
              element.name = details.name;
            });
            this.totalPages = parseInt(response.data.totalPages, 10);
            this.pageNumbers = response.data.pageable.pageNumber;
          }
        })
            .catch(() => {
            })
      }
    },

    updateClassification: function (payload) {
      this.$vs.loading();
      const item = this.item;
      item.displayFullContent = item.origin;
      this.$processor.post('/user-data/update-classification', payload).then(() => {
        this.changeClassificationColor(this.userTopics, item);
        this.loadData();
        this.loadDataNofity += 1;
        this.$eventBus.$emit('loadDataNotify', this.loadDataNofity);
        this.$vs.loading.close();
      })
    },
    changeClassificationColor: function (userTopic, item) {
      if (item.origin) {
        item.displayFullContentOrigin = item.displayFullContent;
        for (let topic of userTopic) {
          if (this.topicId && topic.id != this.topicId) continue;
          for (let keyword of topic.keywords) {
            let userKeyword = keyword.keyword;
            let keywordIndex = item.displayFullContent.toLowerCase().indexOf(userKeyword.toLowerCase())
            if (keywordIndex >= 0) {
              item.displayFullContent = item.displayFullContent.slice(item.displayFullContent.slice(0, keywordIndex).lastIndexOf(".") + 1);

              if (item.classification == 1) {
                item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(39, 125, 246);font-weight: 500;">${userKeyword}</b>`);
                item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(39, 125, 246);font-weight: 500;">${userKeyword}</b>`);
              }
              if (item.classification == -1) {
                item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
                item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
              }
              if (item.classification == 0) {
                item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
                item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
              }
            }
          }

          if (!item.displayFullContent) {
            item.displayFullContent = item.displayFullContent.slice(0, item.displayFullContent.indexOf("."));
          }
        }
      }
    },
    updatePositive: function (item) {
      if(item.classification == 1){
        return this.$vs.notify({
          text: this.$t('articleBookmark.textTchc'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }
      this.item = item;
      item.classification = 1;
      const payload = {
        id: item.id,
        classification: 1
      }
      this.updateClassification(payload);
    },
    updateNegative: function (item) {
      if(item.classification == -1){
        return this.$vs.notify({
          text:this.$t('articleBookmark.textTc'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }
      this.item = item;
      item.classification = -1;
      const payload = {
        id: item.id,
        classification: -1
      }
      this.updateClassification(payload);
    },
    updateInter: function (item) {
      if(item.classification === 0){
        return this.$vs.notify({
          text:this.$t('articleBookmark.textTl'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }
      this.item = item;
      item.classification = 0;
      const payload = {
        id: item.id,
        classification: 0
      }
      this.updateClassification(payload);
    },
    updateUndefined: function (item) {
      this.item = item;
      item.classification = 2;
      const payload = {
        id: item.id,
        classification: 2
      }
      this.updateClassification(payload);
    },
    copyLink: function (e) {
      let link = e.currentTarget.getAttribute('data-url');
      const textArea = document.createElement('textarea');
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("Copy");
      textArea.style.display = "none";
      this.$vs.notify({
        text: this.$t('articleBookmark.textCopy'),
        iconPack: 'feather',
        icon: 'icon-alert',
        color: 'primary'
      })
    },
    isSpam: function () {
      this.$vs.loading();
      let item = this.itemSpam;
      let itemBookmark=this.isBookmark;
      const payload = {
        id: item.id,
      }
      if(item.isBookmark==false){
      this.$processor.post('/user-data/spam', payload).then((response) => {
        this.loadData();
        this.$vs.loading.close();
        return this.$vs.notify({
          text: this.$t('articleBookmark.isSpamSuccess'),
          iconPack: 'feather',
          icon: 'icon-alert',
          color: 'primary'
        })
      }).catch(()=>{
        this.$vs.loading.close();
        return this.$vs.notify({
          text: this.$t('articleBookmark.isSpamUnSuccess'),
          iconPack: 'feather',
          icon: 'icon-alert',
          color: 'danger'
        })
      })
      }else {
        this.$processor.post('/user-data/update-bookmark', payload).then(() => {
          this.$processor.post('/user-data/spam', payload).then(()=>{
            this.loadData();
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('articleBookmark.isSpamSuccess'),
              iconPack: 'feather',
              icon: 'icon-alert',
              color: 'primary'
            })
          }).catch(()=>{
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('articleBookmark.isSpamUnSuccess'),
              iconPack: 'feather',
              icon: 'icon-alert',
              color: 'danger'
            })
          })
        })
      }
    },
    confirmSpam(item) {
      this.itemSpam = item;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('articleBookmark.titleTick'),
        text:this.$t('articleBookmark.textTick'),
        accept: this.isSpam,
        acceptText: this.$t('articleBookmark.acceptText'),
        cancelText: this.$t('articleBookmark.cancelText')
      })
    },
    getAllNews: function () {
      this.facePostCheckBox = false;
      this.faceCommentCheckBox = false;
      this.newsPostCheckBox = false;
      this.currentPage = 1;
      this.findAll = true;
      this.$vs.loading();
      this.loadData();
    },
    getAllSocial: function () {
      this.facePostCheckBox = false;
      this.faceCommentCheckBox = false;
      this.newsPostCheckBox = false;
      this.currentPage = 1;
      this.findAll = true;
      this.$vs.loading();
      this.loadData();
    },
    nFormatter: function (num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return num;
    },

    // Topic-API

    getListTopic: function () {
      const payload = {};
      return new Promise((resolve, reject) => {
        this.$business.post('/topic/find-by-conditions', payload).then((response) => {
          this.$business.post(`share-topic/get-all-share`, payload).then((res) => {
            const topicShare = res.data.filter(el => el.status == 1);
            this.optionalsTopic = [...response.data, ...topicShare];
            this.userTopics = [...response.data, ...topicShare];
            const inputSuggest = this.optionalsTopic;
            this.simpleSuggestionList = inputSuggest;
            if (this.optionalsTopic.length > 0) {
              this.optionalsTopic = this.optionalsTopic.map(el => {
                return {
                  label: el.topicName,
                  value: el.id
                }
              })
              if (this.topicId) {
                let selectedItem = this.optionalsTopic.find(item => item.value == this.topicId)
                if (selectedItem) this.topicSelected = selectedItem;
              }
              this.optionalsTopic.unshift({
                label: this.$t('articleBookmark.all'),
                value: null
              })
            }
            resolve()
          })
        })
            .catch(() => {
              reject()
            })
      })

    },
    mouseHover: function (item) {
      item.active = true;
    },
    mouseLeave: function (item) {
      item.active = false;
    },
    mouseHoverClassification: function (item) {
      item.activeClassification = true;
    },
    mouseLeaveClassification: function (item) {
      item.activeClassification = false;
    },

    // User-API


    //Topic
    findByTopicId: function () {
      this.currentPage = 1;
      this.$vs.loading();
      this.loadData();
      this.$vs.loading.close();

    },
    searchByKeyword: function () {
      this.$vs.loading();
      this.loadData()
    },


    //Date-range-picker
    formatDate: function (val) {
      return moment(val).format("DD/MM/YYYY");

    },
    dateFormat: function (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    updateValues: function () {
      this.loadData();
      this.$vs.loading.close();

    },
    updateI18n: function(){
      this.valueText = this.$t('articleDetail.newsFeed')
      this.valueTextAll = this.$t('articleDetail.all');
    },
    initScreen: function () {
      this.labelReaction = this.$t('articleBookmark.all')
      this.iconFilter = emoji;
      this.valueOldestPost = null;
      this.valueInteractive = null;
      this.classification = null
      this.updateI18n()
      this.valueText = this.$t('articleDetail.newsFeed')
      this.valueTextAll = this.$t('articleBookmark.all');
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueInteractiveUp = null;

      if (this.labelSocial) {
        this.facePostCheckBox = true;
        this.faceCommentCheckBox = true;
        this.newsPostCheckBox = false;
      }
      if (this.labelNews && !this.facePost && !this.faceComment) {
        this.facePostCheckBox = false;
        this.faceCommentCheckBox = false;
        this.newsPostCheckBox = true;
      }
      if (!this.newsPostCheckBox && !this.facePostCheckBox && !this.faceCommentCheckBox && !this.youtubeCheckBox && !this.forumCheckbox && !this.googleCheckBox) {
        this.findAll = true;
      }
      if (this.showFacebookProfile == true && this.showFacebookComment == true) {
        this.findAll = true;
        this.faceCommentCheckBox = false;
        this.facePostCheckBox = false;
      }
      if (this.showNewsPost == true) {
        this.findAll = true;
        this.newsPostCheckBox = false;
      }
      this.getListTopic().then(() => {
        // this.getListFacebook();
        if (this.initial) {
          this.loadData();
        }
        this.getDataSource();
      });
      // this.loadNotifyWarning();

    },
    loadNotifyWarning: function(){
      const payload = {
        start: 0,
        length: 10
      }
      this.$processor.post('warning-message/list', payload).then(() => {
      })
    },
    searchByReaction: function (item) {
      this.selectedHaha = null;
      this.selectedAngry = null;
      this.selectedCare = null;
      this.selectedLike = null;
      this.selectedWow = null;
      this.selectedSad = null;
      this.selectedLove = null;
      switch (item.text) {
        case 'like':
          this.selectedLike = 1;
          this.labelReaction = this.$t('articleBookmark.like')
          this.iconFilter = item.icon;
          break;
        case 'love':
          this.selectedLove = 1;
          this.labelReaction = this.$t('articleBookmark.love')
          this.iconFilter = item.icon;
          break;
        case 'haha':
          this.selectedHaha = 1;
          this.labelReaction = 'Haha';
          this.iconFilter = item.icon;
          break;
        case 'sad':
          this.selectedSad = 1;
          this.labelReaction = this.$t('articleBookmark.sad')
          this.iconFilter = item.icon;
          break;
        case 'wow':
          this.selectedWow = 1;
          this.labelReaction = this.$t('articleBookmark.wow')
          this.iconFilter = item.icon;
          break;
        case 'care':
          this.selectedCare = 1;
          this.labelReaction = this.$t('articleBookmark.care')
          this.iconFilter = item.icon;
          break;
        case 'angry':
          this.selectedAngry = 1;
          this.labelReaction = this.$t('articleBookmark.angry')
          this.iconFilter = item.icon;
          break;
        case 'all':
          this.labelReaction = this.$t('articleBookmark.all')
          this.iconFilter = item.icon;
          this.selectedLike = null;
          this.selectedLove = null;
          this.selectedHaha = null;
          this.selectedSad = null;
          this.selectedWow = null;
          this.selectedCare = null;
          this.selectedAngry = null;
          break;
      }
      this.currentPage = 1;
      this.$vs.loading();
      this.loadData();
    },
    updateBookmark: function (item) {
      this.$vs.loading();
      const payload = {
        id: item.id
      }
      this.$processor.post('/user-data/update-bookmark', payload).then(() => {
        this.loadData();
        this.$vs.loading.close();
        if (item.isBookmark == false) {
          this.$vs.notify({
            text: this.$t('articleBookmark.textSave'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'primary'
          })
        } else {
          this.$vs.notify({
            text: this.$t('articleBookmark.textUnsave'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'primary'
          })
        }

      })
    }
  },
  async created() {
    this.initScreen()
    this.$eventBus.$on('i18n', (event) =>{
      this.initScreen();
    })
  },
}
</script>
<style scoped>


.marginLeft {
  width: 7% !important;
}

.mxh {
  width: 9% !important;

}

.down-width {
  width: 1% !important;
}

.vx-row {
  padding-bottom: 10px;
}

.post {
  font-size: 16px;
}

.fromTo {
  font-size: 13px;
  margin-right: 5%;
}

.titlePost {
  font-size: 13px;
  margin-left: 5px;
}

.like {
  font-size: 13px;
  color: #ccc;
}

.cartPost {
  width: 60% !important;
}

.dropDownBorder {
  border-top: 1px solid #ccc;
  margin-top: 10px;
}

.borderAndMarginBottom {
  border-bottom: 1px solid rgb(238, 234, 234);
  margin-bottom: 5px;
}

.marginRight {
  margin-left: 30%;
}

.iconGridLayout {
  padding-bottom: -5px;
}

.facebook-name {
  font-size: 15px;
  color: #277DF6
}

.facebook-icon {
  background-color: #3B5998;
  color: white;
  margin-right: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border-radius: 70%;
}

.vs-popup {
  width: 50%;
}

.margin-dropdown {
  margin-left: 5% !important
}

.con-vs-dropdown--menu {
  z-index: 420000;
}

.vertical-icon {
  vertical-align: middle
}

.link-post {
  float: right;
  margin-top: 10px
}

.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3 !important; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.text-news {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6 !important; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.text-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.comment {
  margin-left: 1px;
}

.radio-margin-bottom-border {
  border-top: 1px solid #ccc;
  margin: 0px 0px 5px 0px;
  text-align: center;
  padding-top: 5px;
}

.image-post {
  max-width: 100%;
  margin-top: 10%;
  max-height: 100%;
}

.checkbox-min {
  min-width: 150px;
}

.top-right {
  position: absolute;
  top: 5px;
  right: 5px;
}

.reportrange-text {
  height: auto;
}

.vx-navbar-dropdown {
  width: 170px;
}

.fade-leave-active {
  transition: opacity 0.1s
}

.highlight {
  background-color: yellow;
}

.viewtotals {
  position: absolute;
  right: 33.5%;
  width: 200px;
}

.viewtotalsFull {
  position: absolute;
  right: 10px;
  width: 200px;
}

.page-views {
  position: absolute;
  left: 240px;
  width: 200px;
}

.facebook-profile {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 11vw;
  min-width: 70px;
  background-color: #277DF6;
  border-radius: 3px;
  text-align: center;
  color: white;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.classification {
  position: absolute;
  top: 5px;
  margin-left: 25%;
}

.classification-n {
  position: absolute;
  top: 5px;
  margin-left: 6%;
}

.classification-f {
  position: absolute;
  top: 5px;
  margin-left: 6%;
}

.article-news {
  border-radius: 3px;
  border: 1px solid #ccc;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 24px;
  min-width: 150px;
  margin-right: 10px;
}

.article-news:hover {
  border-radius: 3px;
  border: 1px solid #277DF6;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 24px;
  min-width: 150px;
  margin-right: 10px;
  color: rgb(91, 165, 214)
}

.active {
  border-radius: 3px;
  border: 1px solid #277DF6;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 24px;
  min-width: 150px;
  margin-right: 10px;
  color: rgb(91, 165, 214)
}

.actives {
  border-radius: 3px;
  border: 1px solid #277DF6;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 28px;
  min-width: 150px;
  margin-right: 10px;
  color: rgb(91, 165, 214)
}

.topic-selected {
  top: 20px;
  left: 100px;
  position: absolute;
  width: 200px;
}

.text-topic {
  position: absolute;
  left: 20px;
  width: 70px;
}

.search {
  position: absolute;
  right: 8px;
  top: 13px;
  min-width: 200px;
}

.inline {
  white-space: pre-line;
  white-space: pre-wrap;
}

.content-popup {
  width: 97%;
  text-align: justify
}

.copy-link {
  /* position: absolute;
  bottom:4rem;
  min-width: 140px; */
}

.spam {
  right: 5px;
}

.link-content {
  /* position: absolute;
  right: 90px;
  bottom: 4rem; */
}

.dash {
  margin-bottom: 10px
}

.text-reaction {
  text-align: center;
  width: 24.66667% !important;
}

.reaction-detail {
  position: absolute;
  top: 7rem;
  right: 1rem;
  width: 70%;
  z-index: 999;
  background-color: rgba(236, 242, 249);
}

.classification-detail {
  position: absolute;
  top: 4.8rem;
  right: 1rem;
  width: 24rem;
  left: 22%;
  z-index: 999;
  background-color: rgba(236, 242, 249);
}

.classification-fb {
  position: absolute;
  top: 7rem;
  right: 1rem;
  width: 24rem;
  left: 22%;
  z-index: 999;
  background-color: rgba(236, 242, 249);
}

.reaction-card {
  border-radius: 0.5rem;
  margin: -15px 0px 10px;
  background-color: rgb(236, 242, 249)
}

.reaction-card-news {
  border-radius: 0.5rem;
  margin: -15px 0px 10px;
  background-color: rgb(236, 242, 249);
  margin-top: 0rem;
  height: 3rem;
  width: 30rem !important;
  margin-left: 6%;
}

.w-page {
  width: 25.8rem;
}

.popup-detail {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  max-height: 10rem;
}

.popup-detail::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
  border-radius: 5px;
}

.popup-detail::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}

.popup-detail::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border: 1px solid #cccccc;
}

.blue-classification {
  background-color: #277df6 !important;
}

.yellow-classification {
  background-color: #f3cc60 !important;
}

.red-classification {
  background-color: #e60004 !important;
}

.color-text {
  color: #626262 !important
}

.color-text:hover {
  background-color: #277df6 !important;
  color: white !important
}

.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}

.daterangepicker {
  border-left: none !important;
}

@media (max-width: 1366px) {
  .chart-classification {
    width: 7.5rem !important;
  }
}

@media (max-width: 1920px) {
  .chart-classification {
    width: 11rem;
  }
}

.vs-dropdown--custom {
  overflow: auto !important;
}

.title-size {
  font-size: 16px !important;
}

.text-size {
  font-size: 12px !important;
}
</style>
